import { SharedServiceRegistry } from './../../../../shared/shared-service-registry';
import { UserPreferenceService } from './../../../../layout/home/services/user-preference.service';
import { Component, OnInit } from '@angular/core';
import { ResourceService, AlertService } from 'sce-core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SimpleEntityDataService } from './../../../../shared/services/searchable-entity/simple-entity/simple-entity-data.service';
import { SearchService } from './../../../../shared/search/search.service';
import { SearchParams } from '../../../../shared/search/models/search-params.model';
import { SearchStatus } from './../../../../shared/search/models/search-status.model';
import { ViewMyPrintJobsButtonService } from './../services/view-my-print-jobs-button.service';
import { UserPreferenceEvent, DELETE_FAVOURITE, ADD_FAVOURITE } from '../../../../shared/models/user-favourite-event';
import { ViewMyPrintJobsActionService } from '../services/view-my-print-jobs-action.service';
import { SearchEvent } from '../../../../shared/search/models/search-event';
import { NEW_SEARCH_EVENT } from '../../../../shared/search/search-constants';
import { UserService } from '../../../../core/security/user.service';
import { SearchCriteria, Condition, Clause } from '../../../../shared/search/models/search-filter-model';

@Component({
  selector: 'lfwms-view-my-print-jobs-search',
  templateUrl: './view-my-print-jobs-search.component.html',
  styleUrls: ['./view-my-print-jobs-search.component.css'],
  providers: []
})
export class ViewMyPrintJobsSearchComponent implements OnInit {

  private userService: UserService;
  private alertService: AlertService;
  private resourceService: ResourceService;
  private userPreferenceService: UserPreferenceService;
  private favouritePreference: any;
  protected searchParams: SearchParams;
  protected searchStatus: SearchStatus;
  public isFavourite: boolean = false;
  public searchService: SearchService;

  constructor(coreServiceRegistry: CoreServiceRegistry,
      sharedServiceRegistry: SharedServiceRegistry,
      public dataService: SimpleEntityDataService,
      public buttonService: ViewMyPrintJobsButtonService,
      public actionService: ViewMyPrintJobsActionService) {
    this.userService = coreServiceRegistry.userService;
    this.resourceService = coreServiceRegistry.resourceService;
    this.alertService = sharedServiceRegistry.alertService;
    this.userPreferenceService = sharedServiceRegistry.userPreferencesService;
  }

  public getLabel(key: string): string {
    return this.resourceService.get(key);
  }

  public ngOnInit() {
    this.userPreferenceService
      .fetchTablePreferences('printmyjobtd', 'FAVOURITECONFIG')
      .subscribe((favouritePreference: any) => {
        this.favouritePreference = favouritePreference;
        this.isFavourite = this.favouritePreference.configuration.favourite;
      });
    this.userPreferenceService.receiveEvent()
      .subscribe((event: UserPreferenceEvent) => {
        if (event.source === 'search') {
          // if this event originated from the search page, ignore it. It will be handled separately
          return;
        }
        if (event.type === DELETE_FAVOURITE) {
          if (!this.favouritePreference.preferenceId
              || (event.preferenceId === this.favouritePreference.preferenceId)) {
            this.isFavourite = false;
            this.favouritePreference.configuration.favourite = false;
            this.favouritePreference.preferenceId = null;
          }
        }
      });
    this.searchService = this.dataService.searchService;
    this.searchService.setSearchCriteria({
      conditions: []
    });
    this.searchService.fetchMetadata()
      .subscribe(() => {
        const defaultSearchCriteria = new SearchCriteria();
        defaultSearchCriteria.conditions = [];
        defaultSearchCriteria.loadDefaultCriteria = false;
        const defaultCondition = new Condition();
        defaultCondition.id = 1;
        defaultCondition.displayMode = 'VIEW';
        defaultCondition.isReadOnly = true;
        defaultCondition.isMandatory = true;
        const defaultOwnerClause = new Clause();
        defaultOwnerClause.operation = '=';
        defaultOwnerClause.column = 'owner';
        if (this.userService.userInfo.ldapDomain) {
            defaultOwnerClause.value = this.fetchDomain().toUpperCase() + '\\' + this.userService.userInfo.userName;
        } else {
            defaultOwnerClause.value = this.userService.userInfo.userName;
        }
        defaultOwnerClause.logicalOperation = null;
        defaultCondition.clauses.push(defaultOwnerClause);
        defaultCondition.operator = null;
        defaultSearchCriteria.conditions.push(defaultCondition);
        this.searchService.setSearchCriteria(defaultSearchCriteria);
        this.searchService.performSearch();
      });
    this.searchService.receiveEvent()
      .subscribe(($event: SearchEvent) => {
        if ($event.type === NEW_SEARCH_EVENT) {
          this.actionService.showSearchFilterPopup = false;
        }
      });
  }

  private fetchDomain(): string {
    const domains = this.userService.userInfo.ldapDomain.split(',');
    return domains[0].split('=')[1];
  }

  public toggleFavourites() {
    // if the page is set as favourite
    if (!this.isFavourite) {
      this.favouritePreference.configuration.favourite = true;
      this.userPreferenceService
        .saveTablePreferences(this.favouritePreference)
        .subscribe((data: any) => {
          this.isFavourite = true;
          this.favouritePreference.preferenceId = data['preferenceId'];
          this.notifyUserPreferenceEvent(ADD_FAVOURITE);
          this.alertService.success(this.resourceService.get('msg_fav_add'));
        }, (error: any) => {
          this.alertService.clearAll().error(this.resourceService
            .get(error.error.errors['0'].validationMessage));
        });
    } else {
      this.userPreferenceService
        .deleteFavorites(this.favouritePreference.preferenceId)
        .subscribe((data: any) => {
          this.notifyUserPreferenceEvent(DELETE_FAVOURITE);
          // Resetting favourites flag logic will be handled inside above event callback
          this.alertService.success(this.resourceService.get('msg_fav_del'));
        });
    }
  }

  private notifyUserPreferenceEvent(type: number, isExternal?: boolean) {
    const event = new UserPreferenceEvent();
    event.type = type;
    event.source = 'search';
    if (isExternal) {
      event.isExternal = isExternal;
    }
    this.userPreferenceService.notifyEvent(event);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/view-my-print-jobs/view-my-print-jobs-search/view-my-print-jobs-search.component.ts